import uploadAvatar from '../../utils/uploadAvatar';
import * as userSelectors from '../../selectors/user';

const uploadGroupAvatar = (file) => (_, getState) => {
  const state = getState();
  const { sessionToken } = userSelectors.currentUser(state);
  return uploadAvatar({
    sessionToken,
    file,
  });
};

export default uploadGroupAvatar;
